/// <reference path="../shared/providers/loader.service.ts" />
/// <reference path="../shared/providers/loader.service.ts" />
import { Component, OnInit, ElementRef, ViewChild, TemplateRef } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { UserManagerService } from '../shared/providers/user-manager.service';
import { IUserDetails } from '../shared/models/UserDetailsOutputModel';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { RestService } from '../shared/providers/rest.service'
import { IStatesList } from '../shared/models/StatesListOutputModel'
import { IUserInput } from '../shared/models/UserInputModel';
import { ICities } from '../shared/models/CitiesListOutputModel'
import { IUserRole } from '../shared/models/UserRoleOutputModel';
import { ILookUp } from '../shared/models/LookUpOutputModel';
import { IUserCreationResponseModel } from '../shared/models/UserCreationResponseModel';
import { FileUploadService } from '../shared/providers/fileupload.service';
import { IFileUpload } from '../shared/models/fileupload';
import { ValidationService } from '../shared/providers/validation.service';
import { ToastService } from '../shared/providers/toast.service'
import { CommonService } from '../shared/providers/common.service'
import { UserRole, UserStatus, YesNo } from '../shared/enum/enum';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { AuthenticationService } from '../shared/auth/authentication.service';
import { LoaderService } from '../shared/providers/loader.service';
import { AuthService } from '../shared/auth/auth.service';
import { PropertyListingService } from '../shared/providers/property-listing.service';
import { IPropertyAccessInputModel } from '../shared/models/PropertyAccessInputModel';
import { DashboardService } from '../shared/providers/dashboard.service';
import { IInvitePrincipal } from '../shared/models/IInvitePrincipal';
import { IForgotPassword } from '../shared/models/forgotpasswordInput';
import { ForgotPasswordService } from '../shared/providers/forgot-password.service';
import { PermissionService } from '../shared/providers/permission.service';
import { Actions, Modules } from '../shared/enum/enum';

@Component({
  selector: 'principal-edit',
  templateUrl: './principal-edit.component.html',
  styleUrls: ['./principal-edit.component.css']

})
export class PrincipalEditComponent implements OnInit {

  statesList: IStatesList[];
  citiesList: ICities[];
  newUserPassword = '';
  confirmPassword = '';
  userRoleList: IUserRole[];
  lookupList: ILookUp[];
  userInputModel = {} as IUserInput;
  userCreationResponseModel = {} as IUserCreationResponseModel;
  forgotPasswordModel = {} as IForgotPassword;
  fileUploadType: string = "single";
  inputFileUpload = {} as IFileUpload;
  DefaultIndexCount: number = 0;
  userGuid: string = "0";
  userDetailsOutput = {} as IUserDetails;
  IsEditMode: boolean = false;
  fileExtensionType: string = "image";
  IsAdd: boolean = false;
  passwordValidation: string = "";
  @ViewChild('profilePic') profilePic: ElementRef;
  accessModel = {} as IPropertyAccessInputModel;
  pageHeading = "Add Registered User Details";
  imageIdToDelete: number;
  deleteTask: string;
  deleteTaskId: number;
  modalRef: BsModalRef;
  loggedUserDetails: any;
  userEmailID: string;
  IsBlocked: boolean = false;
  IsDeleted: boolean = false;
  IsFRomUserPortfolio: boolean = false;
  prevPage = "External Users";
  prevPageRouteLink = "/users/registered-users";
  hasMyPortfolioAccess: number = 0;
  prosepctsList = [] as any;
  ModelAccess = {} as any;
  exchangeList = [] as any;
  show1031Exchanges = false;
  showSellerData = false;
  myPortfolioRequestText: string = '';
  userRequestedMyPortfolio: boolean = false;
  showUpdatePassword = false;
  isDisabled = false;
  Modules = Modules;
  Actions = Actions;

  constructor(private _restService: RestService, private _userManagerService: UserManagerService, public permissionService: PermissionService, private _fileUploadService: FileUploadService, private forgotPasswordService: ForgotPasswordService, private router: Router, public validationService: ValidationService,
    private activatedRoute: ActivatedRoute, private _toastService: ToastService, private _commonService: CommonService, private modalService: BsModalService,
    private authService: AuthenticationService, private _dashboardService: DashboardService, private Loader: LoaderService, private _auth0: AuthService, private propertyListing: PropertyListingService) {

    this.activatedRoute.queryParams.subscribe((params: Params) => {
      this.userGuid = params['principal'];
      this.prevPage = ((this.authService.Admin() || this.authService.SuperAdmin()) && params['PrevPage'] != undefined && params['PrevPage'] != null) ? params['PrevPage'] : 'External Users';
      if (this.userInputModel.ProfilePicPath === undefined || this.userInputModel.ProfilePicPath === null || this.userInputModel.ProfilePicPath.trim().length <= 0) {
        this.userInputModel.ProfilePicPath = '/../../../assets/img/default-profile-img.png'
      }
      if (this.prevPage == 'User Portfolios') {
        this.IsFRomUserPortfolio = true;
        this.prevPage = 'User Details';
      }
    });
  }

  selectedFiles: string[] = [];
  clearFiles: number = 0;

  selectedFilesListEmitter(selectedFilesListEmitter: string[]) {
    this.selectedFiles = selectedFilesListEmitter;
  }
  selectedFilePathEmitter(selectedFilePathEmitter: any) {
    this.profilePic.nativeElement.src = selectedFilePathEmitter;
  }

  setUploadDefaultValues() {
    this.inputFileUpload.fileCategoryId = 251;
    this.inputFileUpload.id = 0;
    this.inputFileUpload.objectId = 0;
    this.inputFileUpload.objectTypeId = 301;
    this.inputFileUpload.documentName = "User Profile Pictuer";
    this.inputFileUpload.type = "Images";
  }

  uploadFiles() {

    this._fileUploadService.uploadFiles(this.inputFileUpload, this.selectedFiles).subscribe(response => {
      this.clearFiles++;
      this.redirectToListingPage();
    });
  }
  OnClickLink() {
    if (this.IsFRomUserPortfolio) {
      this.router.navigateByUrl('/registered-user-details?principal=' + this.userGuid + '&prevPage=User Portfolios&prevPageRouteLink=/view-portfolio');
    }
    else {
      this.router.navigateByUrl(this.prevPageRouteLink);
    }
  }
  isPassword(search: string): boolean {
    var searchfind: boolean;
    var regexp = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})");
    searchfind = regexp.test(search);
    return searchfind;

  }
  onKeydown(event) {
    if (event.key === "Enter") {
      this.saveUser();
    }
  }
  IsinValid(value: any) {

    if (value == undefined || value == '' || value == null) {
      return true;
    }
    if (value.toString().trim().length <= 0) {
      return true;
    }
    if (!value) {
      return true;
    }
    return false;
  }
  validatepassword() {
    if ((this.isPassword(this.userInputModel.Password) == false) && !this.IsinValid(this.userInputModel.Password)) {
      this.passwordValid = false;
      this.passwordValidation = "Must contain at least one number, one uppercase letter, one lowercase letter and at least 8 characters";
    }
    else {
      this.passwordValid = true;
      this.passwordValidation = "";
    }
    if (this.IsinValid(this.userInputModel.Password)) {
      this.passwordValid = false;
    }
  }
  validatechangepassword() {
    if ((this.isPassword(this.newUserPassword) == false) && !this.IsinValid(this.newUserPassword)) {
      this.passwordValid = false;
      this.passwordValidation = "Must contain at least one number, one uppercase letter, one lowercase letter and at least 8 characters";
    }
    else {
      this.passwordValid = true;
      this.passwordValidation = "";
    }
    if (this.IsinValid(this.newUserPassword)) {
      this.passwordValid = false;
    }
  }
  IsPrincipal = true;
  IsBroker = false;
  IsSeller = false;
  tickers = [];
  ngOnInit() {

    this.activatedRoute.queryParams.subscribe((params: Params) => {
      let routeName = params['prevroute'];
      let routeLink = params['link'];
      if (routeName !== null && routeName !== undefined) {
        this.prevPage = routeName;
        this.prevPageRouteLink = routeLink;
      }
      //if (params['property_tab'] !== null && params['property_tab'] !== undefined) {
      //    this.tabToShow = params['property_tab'];
      //}
      //else if (params['tab'] !== null && params['tab'] !== undefined) {
      //    this.tabToShow = params['tab'];
      //}
    });

    this.authService.isLoggedIn.subscribe(response => {
      if (response) {
        this.loggedUserDetails = this.authService.user;
        this.userInputModel.CreatedById = this.loggedUserDetails.Id;
      }
    });

    this.setUploadDefaultValues();
    this._commonService.getStateList().subscribe(response => {
      this.statesList = response.map(o => { return { Id: o.Id, Name: o.StateName }; });
    });

    this._commonService.getUserRolesList().subscribe(response => {
      this.userRoleList = response.map(o => { return { id: o.Id, name: o.Description }; });
    });

    this._commonService.getLookupsByTypeId(1).subscribe(response => {
      this.lookupList = response.filter(x => x.Id != 103).map(o => { return { id: o.Id, description: o.Description }; });
    });

    this.userInputModel.StateId = 0;
    this.userInputModel.CityId = 0;
    this.userInputModel.UserStatus = 0;
    this.userInputModel.UserRoleId = UserRole.Principal;

    if (this.userGuid != undefined) {
      this._userManagerService.getUserDetails(this.userGuid).subscribe(response => {
        if (this.permissionService.hasPermission(Modules.ExternalUsers, Actions.ChangePassword)) {
          this.showUpdatePassword = true;
        }
        else {
          this.showUpdatePassword = false;
        }
        ////console.log(response.BrokerRegionalLicensesOutputModelList);
        this.userEmailID = response.Email;
        this.userInputModel.Id = response.Id;
        this.userInputModel.UserGuid = this.userGuid;
        this.userInputModel.FirstName = response.FirstName;
        this.userInputModel.LastName = response.LastName;
        this.userInputModel.EmailAddress = response.Email;
        this.userInputModel.PhoneNumber = response.Phoneno;
        this.userInputModel.Address1 = response.Address1;
        this.userInputModel.Address2 = response.Address2;
        this.userInputModel.StateId = response.StateId;
        this.bindCity();
        this.userInputModel.CityId = (response.CityId == null ? 0 : response.CityId);
        this.userInputModel.Zip = response.Zip;
        this.userInputModel.IsAvailablePropertyAccessEnabled = response.IsAvailablePropertyAccessEnabled;
        this.userInputModel.IsOffMarketPropertyAccessEnabled = response.IsOffMarketPropertyAccessEnabled;
        this.userInputModel.IsSellerDashboardEnabled = response.IsSellerDashboardEnabled;
        this.userInputModel.UserRoleId = response.UserRoleId;
        this.userInputModel.IsOn1031Exchange = response.IsOn1031Exchange;
        this.userInputModel.UserRoleIdList = response.UserRoleIdList;
        this.userInputModel.IsMyPortfolioEnabled = response.IsMyPortfolioEnabled;
        this.userInputModel.Is1031RequestSent = response.Is1031RequestSent;
        this.userInputModel.IsStandardUser = response.IsStandardUser;
        this.userInputModel.Is1031InquirySubmitted = response.Is1031InquirySubmitted;
        this.userInputModel.Is1031User = response.Is1031User;
        this.userInputModel.IsMyPortfolioRequested = response.IsMyPortfolioRequested;
        this.userInputModel.IsAvailablePropertyRequested = response.IsAvailablePropertyRequested;
        this.userInputModel.IsOffMarketPropertyRequested = response.IsOffMarketPropertyRequested;
        this.userInputModel.IsSellerDashboardRequested = response.IsSellerDashboardRequested;
        this.userInputModel.Is1031EnabledId = response.Is1031EnabledId;
        if (this.userInputModel.UserRoleId == this.authService.UserRole.ExternalBroker) {
          this.IsBroker = true;
          this.IsPrincipal = false;
        }
        else if (this.userInputModel.UserRoleId == this.authService.UserRole.GuestUser) {
          this.IsBroker = false;
          this.IsPrincipal = false;
        }
        else {
          this.IsBroker = false;
          this.IsPrincipal = true;
          this.hasMyPortfolioAccess = 1;
          if ((this.authService.Admin() || this.authService.Admin()) && this.userInputModel.Is1031User) {
            this.get1031ExchangesDetails(this.userInputModel.Id);
            this.show1031Exchanges = true;
          }
          let myPortfolioRequestaccess = '';
          if (this.userInputModel.IsMyPortfolioRequested && !this.userInputModel.IsMyPortfolioEnabled) {
            myPortfolioRequestaccess = 'My Portfolio Access';
            this.userRequestedMyPortfolio = true;
          }
          if (this.userInputModel.IsAvailablePropertyRequested && !this.userInputModel.IsAvailablePropertyAccessEnabled) {
            myPortfolioRequestaccess = myPortfolioRequestaccess == '' ? 'Available Property Access' : (myPortfolioRequestaccess + ', Available Property Access');
            this.userRequestedMyPortfolio = true;
          }
          if (this.userInputModel.IsOffMarketPropertyRequested && !this.userInputModel.IsOffMarketPropertyAccessEnabled) {
            myPortfolioRequestaccess = myPortfolioRequestaccess == '' ? 'Off-Market Property Access' : (myPortfolioRequestaccess + ', Off-Market Property Access');
            this.userRequestedMyPortfolio = true;
          }
          if (myPortfolioRequestaccess != '') {
            this.myPortfolioRequestText = 'User has Requested ' + myPortfolioRequestaccess;
          }
        }

        if (this.userInputModel.UserRoleIdList.indexOf(this.authService.UserRole.Seller) > -1) {
          this.IsSeller = true;
          if (this.authService.Admin() || this.authService.SuperAdmin()) {
            this.showSellerData = true;
            this.getProspectsDetails(this.userInputModel.Id);
          }
          this.GetTickersForThisUser();
          this.hasMyPortfolioAccess = 1;
        }

        this.userInputModel.UserStatus = response.UserStatusId;
        this.userInputModel.ProfilePicPath = response.ProfilePicPath;
        this.userInputModel.Is1031User = response.Is1031User;
        this.userInputModel.Password = '***********************************************************************';
        this.userInputModel.CompanyName = response.CompanyName;
        this.IsEditMode = true;
        this.pageHeading = "Edit Registered User Details";
        this.imageIdToDelete = response.ImageId;
        if (this.imageIdToDelete != null) {
          $('.profileupload')[0].hidden = true;
        }
        else {
          $('.profileupload')[0].hidden = false;
        }
        if (this.userInputModel.ProfilePicPath === undefined || this.userInputModel.ProfilePicPath === null || this.userInputModel.ProfilePicPath.trim().length <= 0) {
          this.userInputModel.ProfilePicPath = '/../../../assets/img/default-profile-img.png'
        }

      });
    }
    else {
      this.IsAdd = true;
      this.userInputModel.UserStatus = UserStatus.Active;
      this.hasMyPortfolioAccess = 1;
      this.showUpdatePassword = false;
    }

    if (this.userInputModel.ProfilePicPath === undefined || this.userInputModel.ProfilePicPath === null || this.userInputModel.ProfilePicPath.trim().length <= 0) {
      this.userInputModel.ProfilePicPath = '/../../../assets/img/default-profile-img.png'
    }

  }

  private GetTickersForThisUser() {
    this.propertyListing.GetDefaultTickers(this.userInputModel.Id).subscribe(res => {
      this.tickers = res;
    });
  }

  bindCity() {
    this._commonService.getCitiesList(this.userInputModel.StateId).subscribe(response => {
      this.citiesList = response.map(o => { return { Id: o.Id, Name: o.CityName }; });
    });
    this.userInputModel.CityId = 0;
  }

  firstNameValid: boolean = true;
  lastNameValid: boolean = true;
  emailValid: boolean = true;
  emailvalidation: string = "";
  passwordValid: boolean = true;
  phoneValid: boolean = true;
  roleValid: boolean = true;
  userStatusValid: boolean = true;

  showFNSpecCharVal = false;
  showLNSpecCharVal = false;
  specCharValMsg = '!@#$%^&*()_+\-=\[\]{};"\\|<>\/? not allowed';
  saveUser() {
    let IsValid: boolean = true;

    if (this.validationService.IsinValid(this.userInputModel.FirstName)) {
      this.firstNameValid = false;
      this.showFNSpecCharVal = false;
      IsValid = false;
    }
    else {
      if (this.validationService.isSpecialCharacterExist(this.userInputModel.FirstName)) {
        this.firstNameValid = false;
        IsValid = false;
        this.showFNSpecCharVal = true;
      }
      else {
        this.showFNSpecCharVal = false;
        this.firstNameValid = true;
      }

    }
    if (this.validationService.IsinValid(this.userInputModel.LastName)) {
      this.lastNameValid = false;
      this.showLNSpecCharVal = false;
      IsValid = false;
    }
    else {
      if (this.validationService.isSpecialCharacterExist(this.userInputModel.LastName)) {
        this.lastNameValid = false;
        IsValid = false;
        this.showLNSpecCharVal = true;
      }
      else {
        this.showLNSpecCharVal = false;
        this.lastNameValid = true;
      }
    }

    if (this.validationService.IsinValid(this.userInputModel.EmailAddress)) {
      this.emailValid = false;
      IsValid = false;
    }
    else if ((this.validationService.isEmail(this.userInputModel.EmailAddress) == false) && !this.validationService.IsinValid(this.userInputModel.EmailAddress)) {
      this.emailValid = false;
      IsValid = false;
      this.emailvalidation = "invalid Email address";
    }
    else {
      this.emailValid = true;
      this.emailvalidation = "";
    }

    if (!this.IsEditMode) {
      if (this.validationService.IsinValid(this.userInputModel.Password)) {
        this.passwordValid = false;
        IsValid = false;
      }
      else {
        this.passwordValid = true;
      }
      if (this.passwordValid && this.isPassword(this.userInputModel.Password) == false) {
        IsValid = false;
        this.passwordValidation = "Must contain at least one number and one uppercase and lowercase letter, and at least 8 or more characters.";
      }
      else {
        this.passwordValidation = "";
      }
    }

    if (this.validationService.IsinValid(this.userInputModel.PhoneNumber)) {
      this.phoneValid = false;
      IsValid = false;
    }
    else {
      this.phoneValid = true;
    }
    if (this.validationService.IsinValid(this.userInputModel.UserRoleId)) {
      this.roleValid = false;
      IsValid = false;
    }
    else if (this.userInputModel.UserRoleId == 0) {
      this.roleValid = false;
      IsValid = false;
    }
    else {
      this.roleValid = true;
    }

    if (this.validationService.IsinValid(this.userInputModel.UserStatus)) {
      this.userStatusValid = false;
      IsValid = false;
    }
    else if (this.userInputModel.UserStatus == 0) {
      this.userStatusValid = false;
      IsValid = false;
    }
    else {
      this.userStatusValid = true;
    }

    if (IsValid) {
      if (this.validationService.isPhoneNumber(this.userInputModel.PhoneNumber) == false) {
        this._toastService.addToast({ title: 'Error Occurred', msg: 'Invalid phone number', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
        IsValid = false;
        return;
      }
      if (!this.validationService.IsinValid(this.userInputModel.Zip)) {

        if (!this.validationService.IsValidZipCode(this.userInputModel.Zip)) {
          this._toastService.addToast({ title: 'Error Occurred', msg: 'Invalid Zip Code', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
          IsValid = false;
        }
        else {
          IsValid = true;
        }
      }

      if (!this.IsPrincipal && !this.IsBroker && this.userInputModel.UserRoleId != this.authService.UserRole.GuestUser) {
        this._toastService.addToast({ title: 'Error Occurred', msg: 'Please select a role.', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
        IsValid = false;
        return;
      }
    }

    if (IsValid) {
      this.userInputModel.Source = "Principal-Edit";
      if (this.selectedFiles.length > 0) {
        // this._toastService.addToast({ title: 'Processing', msg: 'Please wait...', timeout: 5000, theme: 'bootstrap', position: 'top-center', type: 'wait' })
        this.Loader.display(true);
      }

      if (this.IsBroker) {
        this.userInputModel.UserRoleId = this.authService.UserRole.ExternalBroker;
      }
      else if (this.IsPrincipal) {
        this.userInputModel.UserRoleId = this.authService.UserRole.Principal;
      }

      if (this.userInputModel.UserStatus == UserStatus.Inactive) {
        this.IsBlocked = true;
      }
      if (this.userInputModel.UserStatus == UserStatus.Deleted) {
        this.IsDeleted = true;
      }

      if (!this.IsEditMode) {
        // auth0 crate user//
        this.Loader.display(true);
        this._userManagerService.checkIsGuestUser(this.userInputModel.EmailAddress).subscribe(response => {
          if (response != undefined && response != null && this.IsPrincipal) {
            this._userManagerService.createUser(this.userInputModel).subscribe(response => {
              this.Loader.display(false);
              this.userCreationResponseModel = response;
              if (this.userCreationResponseModel.Success == true) {

                if (this.selectedFiles.length > 0) {
                  this.inputFileUpload.objectId = this.userCreationResponseModel.Id;
                  this.inputFileUpload.id = this.userCreationResponseModel.Id;
                  this.uploadFiles();
                }
                else {
                  this.redirectToListingPage();
                }
              }
              else {
                this._toastService.addToast({ title: 'Error Occurred', msg: this.userCreationResponseModel.FailureMessage, timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
              }
            });
          }
          else {
            this._auth0.auth0CreateUser(this.userInputModel.EmailAddress, this.userInputModel.Password, this.IsBlocked).subscribe(res => {
              res.subscribe(res => {
                if (res["user_id"]) {
                  this._auth0.gerateUserResetPasswordLink(res["user_id"]).subscribe(res => {
                    res.subscribe(res => {
                      this.userInputModel.UserResetPasswordTicket = res["ticket"];
                      this._userManagerService.createUser(this.userInputModel).subscribe(response => {
                        this.Loader.display(false);
                        this.userCreationResponseModel = response;
                        if (this.userCreationResponseModel.Success == true) {

                          if (this.selectedFiles.length > 0) {
                            this.inputFileUpload.objectId = this.userCreationResponseModel.Id;
                            this.inputFileUpload.id = this.userCreationResponseModel.Id;
                            this.uploadFiles();
                          }
                          else {
                            this.redirectToListingPage();
                          }
                        }
                        else {
                          this._toastService.addToast({ title: 'Error Occurred', msg: this.userCreationResponseModel.FailureMessage, timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
                        }
                      });

                    })
                  })
                }
              });
            });
          }
        });
        //----------------//    

      }
      else {
        //auth0 update //
        this.Loader.display(true)
        this._auth0.auth0SearchUserByEmailId(this.userEmailID).subscribe(response => {
          response.subscribe(res => {
            if (res != null && res.length > 0) {
              this._auth0.auth0UpdateUser(res[0]["user_id"], this.userInputModel.EmailAddress, this.IsBlocked, this.IsDeleted).subscribe(res => {
                res.subscribe(res => {
                  this.userInputModel.IsFromPrincipalEdit = true;
                  this._userManagerService.updateUser(this.userInputModel).subscribe(response => {
                    this.Loader.display(false);
                    this.userCreationResponseModel = response;
                    if (this.userCreationResponseModel.Success == true) {

                      if (this.selectedFiles.length > 0) {
                        this.inputFileUpload.objectId = this.userCreationResponseModel.Id;
                        this.inputFileUpload.id = this.userCreationResponseModel.Id;
                        this.uploadFiles();
                      }
                      else {
                        this.redirectToListingPage();
                      }

                      //if (this.IsBlocked == true && this.userInputModel.EmailAddress == this.userEmailID) {
                      //    this._auth0.userList.forEach(item => {
                      //        this._auth0.auth0UpdateUser(item["user_id"], this.userInputModel.EmailAddress, this.IsBlocked, item["identities"][0].connection).subscribe(res => {
                      //            res.subscribe(res => {                                                        
                      //                alert(JSON.stringify(res));
                      //            });
                      //        });
                      //    });
                      //}
                    }
                    else {
                      this._toastService.addToast({ title: 'Error Occurred', msg: this.userCreationResponseModel.FailureMessage, timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
                    }
                  });
                });
              });
            }
            else {
              this.userInputModel.IsFromPrincipalEdit = true;
              this._userManagerService.updateUser(this.userInputModel).subscribe(response => {
                this.Loader.display(false);
                this.userCreationResponseModel = response;
                if (this.userCreationResponseModel.Success == true) {

                  if (this.selectedFiles.length > 0) {
                    this.inputFileUpload.objectId = this.userCreationResponseModel.Id;
                    this.inputFileUpload.id = this.userCreationResponseModel.Id;
                    this.uploadFiles();
                  }
                  else {
                    this.redirectToListingPage();
                  }

                }
                else {
                  this._toastService.addToast({ title: 'Error Occurred', msg: this.userCreationResponseModel.FailureMessage, timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
                }
              });
            }
          });
        });
        //------------//
      }
    }
  }
  clearFeilds() {

    if (!this.IsEditMode) {
      this.router.navigate(['users/registered-users']);
    }
    else {
      this.router.navigate(['/registered-user-details'], { queryParams: { principal: this.userGuid } });
    }
  }


  validateemail() {
    if ((this.validationService.isEmail(this.userInputModel.EmailAddress) == false) && !this.validationService.IsinValid(this.userInputModel.EmailAddress)) {
      this.emailValid = false;
      this.emailvalidation = "invalid Email address";
    }
    else {
      this.emailValid = true;
      this.emailvalidation = "";
    }
    if (this.validationService.IsinValid(this.userInputModel.EmailAddress)) {
      this.emailValid = false;
    }
  }

  setDefault(event: any) {
    if (event.target.checked) {
      this.DefaultIndexCount++;
    }
    else {
      this.DefaultIndexCount--;
    }
  }
  redirectToListingPage() {

    if (!this.IsEditMode) {
      this._toastService.addToast({ title: 'Success', msg: 'User Created Successfully', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' })
    }
    else {
      this._toastService.addToast({ title: 'Success', msg: 'User Details Updated Successfully', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' })
    }
    this.router.navigate(['/registered-user-details'], { queryParams: { principal: this.userCreationResponseModel.Guid.toString() } });
  }

  onRemoveImage(id: number) {
    if (id > 0) {
      //this._toastService.addToast({ title: 'Processing', msg: 'Please wait...', timeout: 2000, theme: 'bootstrap', position: 'top-center', type: 'wait' })
      this._userManagerService.deleteImage(id).subscribe(response => {

        if (response.toString() === 'true') {
          this._toastService.addToast({
            title: 'Success',
            msg: 'Image deleted successfully!',
            timeout: 5000,
            theme: 'bootstrap',
            position: 'bottom-right',
            type: 'success'
          });
          this.userInputModel.ProfilePicPath = '/../../../assets/img/default-profile-img.png';
          this.imageIdToDelete = null;
          $('.profileupload')[0].hidden = false;
        } else {
          this._toastService.addToast({
            title: 'Error Occurred',
            msg: 'Image could not be deleted',
            timeout: 5000,
            theme: 'bootstrap',
            position: 'bottom-right',
            type: 'error'
          });
        }

      });
    }
    else {
      this._toastService.addToast({
        title: 'Success',
        msg: 'Image deleted successfully!',
        timeout: 5000,
        theme: 'bootstrap',
        position: 'bottom-right',
        type: 'success'
      });
    }
  }

  openModalForDelete(template: TemplateRef<any>, classes, taskId: number, task: string) {
    this.deleteTask = task;
    this.deleteTaskId = taskId;
    this.modalRef = this.modalService.show(template, { class: classes });
  }

  onCheckboxSelect(type: number, event) {

    if (event.target.checked) { // if checkbox is checked
      if (type === 1) { // IsPrincipal
        this.IsBroker = false;
        this.IsPrincipal = true;
        this.hasMyPortfolioAccess = 1;
      }
      else if (type === 2) { // Is1031User
        this.IsBroker = false;
        this.IsPrincipal = true;
        this.userInputModel.Is1031User = true;
        this.hasMyPortfolioAccess = 1;
      }
      else if (type === 3) { // IsBroker
        this.IsPrincipal = false;
        this.userInputModel.Is1031User = false;
        this.IsBroker = true;
        this.hasMyPortfolioAccess = 0;

      }
    }
    else {// if checkbox is un checked
      if (type === 1) { // IsPrincipal
        this.userInputModel.Is1031User = false;
        this.IsPrincipal = false;
      }
    }
  }
  modalRefAddTicker: BsModalRef;
  openAddTicker(template: TemplateRef<any>, classes: any) {
    this.modalRefAddTicker = this.modalService.show(template, { class: classes });
  }

  ChangeAccessStatus(type: number) {
    if (type === 1) {
      this.userInputModel.IsAvailablePropertyAccessEnabled = this.userInputModel.IsAvailablePropertyAccessEnabled ? false : true;
      if (this.userInputModel.Id != null && this.userInputModel.Id > 0) {
        this.grantMyPortfolioDashboardAccess(type, this.userInputModel.IsAvailablePropertyAccessEnabled);
      }
    }
    else if (type === 2) {
      this.userInputModel.IsOffMarketPropertyAccessEnabled = this.userInputModel.IsOffMarketPropertyAccessEnabled ? false : true;
      if (this.userInputModel.Id != null && this.userInputModel.Id > 0) {
        this.grantMyPortfolioDashboardAccess(type, this.userInputModel.IsOffMarketPropertyAccessEnabled);
      }
    }
    else if (type === 3) {
      this.userInputModel.IsMyPortfolioEnabled = this.userInputModel.IsMyPortfolioEnabled ? false : true;
      if (this.userInputModel.Id != null && this.userInputModel.Id > 0) {
        this.grantMyPortfolioDashboardAccess(type, this.userInputModel.IsMyPortfolioEnabled);
      }
    }
  }
  onAccessCheckboxSelect(type: number, event) {

    if (event.target.checked) { // if checkbox is checked
      if (type === 1) {
        this.userInputModel.IsAvailablePropertyAccessEnabled = true;

      }
      else if (type === 2) {
        this.userInputModel.IsOffMarketPropertyAccessEnabled = true;
      }
      else if (type === 3) {
        this.userInputModel.IsMyPortfolioEnabled = true;
      }
    }
    else {// if checkbox is un checked
      if (type === 1) {
        this.userInputModel.IsAvailablePropertyAccessEnabled = false;
      }
      else if (type === 2) {
        this.userInputModel.IsOffMarketPropertyAccessEnabled = false;
      }
      else if (type === 3) {
        this.userInputModel.IsMyPortfolioEnabled = false;
      }
    }
  }

  selectedTickerId = 0;
  selectedTickerindex = 0;
  modalRefRemoveTicker: BsModalRef;
  openModalForDeleteTicker(template: TemplateRef<any>, classes: any, tickerId, index) {
    this.selectedTickerId = tickerId;
    this.selectedTickerindex = index;
    this.modalRefRemoveTicker = this.modalService.show(template, { class: classes });
  }

  closeAddTickerModal() {
    this.GetTickersForThisUser();
  }

  removeTicker() {
    this.Loader.display(true);
    this.propertyListing.RemoveTickers(this.selectedTickerId).subscribe(res => {
      if (res["IsSuccess"]) {
        this._toastService.addToast({ title: 'Success', msg: 'Ticker removed successfully', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' })
        this.Loader.display(true);
        this.tickers.splice(this.selectedTickerindex, 1);
      }
      else {
        this._toastService.addToast({ title: 'Error Occurred', msg: 'Failed to remove tickers', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
      }
      this.modalRefRemoveTicker.hide();
      this.Loader.display(false);
    });
  }

  grantOrReject1031Access() {
    if (this.userInputModel.Id != null && this.userInputModel.Id > 0) {
      this.accessModel.Is1031EnabledId = (this.userInputModel.Is1031EnabledId == YesNo.Yes) ? YesNo.No : YesNo.Yes;
      this.accessModel.UserId = this.userInputModel.UserGuid;
      this.userInputModel.Is1031EnabledId = this.accessModel.Is1031EnabledId;

      this._userManagerService.update1031access(this.accessModel).subscribe(response => {
        if (response) {
          this._toastService.addToast({ title: 'Success', msg: 'You have successfully changed the 1031 access status', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' });
          this.ngOnInit();
        }
        else {
          this.userInputModel.Is1031EnabledId = this.accessModel.Is1031EnabledId == YesNo.Yes ? YesNo.No : YesNo.Yes;;
          this._toastService.addToast({ title: 'Error', msg: 'An error Occurred while changing the 1031 access status', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
        }
      });
    }
    else {
      this.userInputModel.Is1031EnabledId = (this.userInputModel.Is1031EnabledId == YesNo.Yes) ? YesNo.No : YesNo.Yes;
    }
  }

  grantSellerDashboardAccess() {
    if (this.userInputModel.Id != null && this.userInputModel.Id > 0) {
      let status = this.userInputModel.IsSellerDashboardEnabled ? false : true;
      this._userManagerService.ChangeSellerDashboardAccess(this.userInputModel.UserGuid, status).subscribe(response => {
        if (response) {
          this.userInputModel.IsSellerDashboardEnabled = status;
          this._toastService.addToast({ title: 'Success', msg: 'You have successfully changed the seller dashboard access status', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' });
        }
        else {
          this._toastService.addToast({ title: 'Error', msg: 'An error Occurred while changing the seller dashboard access status', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
        }
      });
    }
    else {
      this.userInputModel.IsSellerDashboardEnabled = this.userInputModel.IsSellerDashboardEnabled ? false : true;
    }
  }
  grant1031DashboardAccess(userguid, event, id) {
    let status = this.userInputModel.Is1031DashboardEnabled;
    this._userManagerService.Change1031DashboardAccess(this.userInputModel.UserGuid, status, id).subscribe(response => {
      if (response) {
        this._toastService.addToast({ title: 'Success', msg: 'You have successfully changed the 1031 dashboard access status', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' });
      }
      else {
        this._toastService.addToast({ title: 'Error', msg: 'An error Occurred while changing the 1031 dashboard access status', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
      }
    });
  }

  grantMyPortfolioDashboardAccess(type: number, status: boolean) {
    let source = type == 1 ? 'AvailableProperties' : type == 2 ? 'OffMarket' : 'MyPortfolio';
    this._userManagerService.ChangeMyPortfolioAccess(this.userInputModel.UserGuid, source, status).subscribe(response => {
      if (response) {
        let message = type == 1 ? 'Available Properties' : type == 2 ? 'Off Market Properties' : 'My Portfolio';
        this._toastService.addToast({ title: 'Success', msg: ('You have successfully changed the ' + message + ' access status'), timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' });
        this.getMessageContent();
      }
      else {
        let message = type == 1 ? 'Available Properties' : type == 2 ? 'Off Market Properties' : 'My Portfolio';
        this._toastService.addToast({ title: 'Error', msg: ('An error Occurred while changing the ' + message + ' access status'), timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
      }
    });
  }

  getProspectsDetails(userId: number) {
    this.propertyListing.GetProspectsDetails(userId).subscribe(response => {
      this.prosepctsList = response;
    });
  }

  get1031ExchangesDetails(userId: number) {
    this.propertyListing.GetPrincipal1031ExchangeDetails(userId).subscribe(response => {
      this.exchangeList = response;
    });
  }

  prospectText: string = '';
  grantProspectAccess(template: TemplateRef<any>, classes: any, Id: number, access: number) {
    let accessDetails = {
      Id: Id,
      access: access == 1 ? 0 : 1
    }
    this.prospectText = access == 1 ? 'Disabling prospects tab access for this property will remove the ability for all sellers to see the prospects tab. Proceed with this change?'
      : 'Enabling prospects tab access for this property allows all sellers to see the prospects tab. Proceed with this change?';
    this.ModelAccess = accessDetails;
    this.modalRefRemoveTicker = this.modalService.show(template, { class: classes });
  }

  ChangeSellerProspectStatus() {
    if (this.ModelAccess != null && this.ModelAccess.Id != null) {
      let status = this.ModelAccess.access == 1 ? true : false;
      this.Loader.display(true);
      this._dashboardService.saveSellerVisibilityForProspect(this.ModelAccess.Id, status).subscribe(res => {
        if (res) {
          this._toastService.addToast({ title: 'Success', msg: ('You have successfully changed the prospect access status'), timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' });
          this.getProspectsDetails(this.userInputModel.Id);
          this.Loader.display(false);
        }
        else {
          this.getProspectsDetails(this.userInputModel.Id);
          this.Loader.display(false);
        }
      })
    }
  }

  Change1031Dashboard(Id: number, Status: any) {
    if (Id != null && Id != null) {
      let status = Status == false ? true : false;
      this.Loader.display(true);
      this._userManagerService.Change1031DashboardAccess(this.userInputModel.UserGuid, status, Id).subscribe(response => {
        if (response) {
          this._toastService.addToast({ title: 'Success', msg: 'You have successfully changed the 1031 dashboard access status', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' });
          this.get1031ExchangesDetails(this.userInputModel.Id);
          this.Loader.display(false);
        }
        else {
          this._toastService.addToast({ title: 'Error', msg: 'An error Occurred while changing the 1031 dashboard access status', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
          this.Loader.display(false);
        }
      });
    }
  }

  getMessageContent() {
    let myPortfolioRequestaccess = '';
    this.userRequestedMyPortfolio = false;
    if (this.userInputModel.IsMyPortfolioRequested && !this.userInputModel.IsMyPortfolioEnabled) {
      myPortfolioRequestaccess = 'My Portfolio Access';
      this.userRequestedMyPortfolio = true;
    }
    if (this.userInputModel.IsAvailablePropertyRequested && !this.userInputModel.IsAvailablePropertyAccessEnabled) {
      myPortfolioRequestaccess = myPortfolioRequestaccess == '' ? 'Available Property Access' : (myPortfolioRequestaccess + ', Available Property Access');
      this.userRequestedMyPortfolio = true;
    }
    if (this.userInputModel.IsOffMarketPropertyRequested && !this.userInputModel.IsOffMarketPropertyAccessEnabled) {
      myPortfolioRequestaccess = myPortfolioRequestaccess == '' ? 'Off-Market Property Access' : (myPortfolioRequestaccess + ', Off-Market Property Access');
      this.userRequestedMyPortfolio = true;
    }
    if (myPortfolioRequestaccess != '') {
      this.myPortfolioRequestText = 'User has Requested ' + myPortfolioRequestaccess;
    }
  }
  onRedirection(type: string) {
    if (type == 'MyPortfolio') {
      this.router.navigate(['/market-snapshot'], { queryParams: { UserGuid: this.userInputModel.UserGuid.toString(), opentab: '1', FromUrl: this.router.url } })
    }
    else if (type == 'Seller') {

    }
  }

  viewDetail(exguid: any, type: string) {
    if (type == 'prospect') {
      this.router.navigate(['/viewproperty/' + exguid], { queryParams: { prevroute: 'External Users', link: this.router.url } });
    }
    else if (type == '1031Dasboard') {
      this.router.navigate(['/dashboard-1031/' + exguid], { queryParams: { activeTab: '1', prevroute: 'External Users', link: this.router.url } });
    }
  }

  sendResetPassword() {
    this.Loader.display(true);
    this._auth0.auth0SendResetPasswordLinkApi(this.userInputModel.EmailAddress).subscribe(res => {
      this._toastService.addToast({
        title: 'Success',
        msg: 'Reset password link has been sent to your email address!',
        timeout: 5000,
        theme: 'bootstrap',
        position: 'bottom-right',
        type: 'success'
      });
      this.Loader.display(false);
    });

    //  this._auth0.auth0SendResetPasswordLinkApi(this.userInputModel.EmailAddress);
  }

  updatePassword() {
  }

  checkPasswordValidity(event) {
    if (event.key === "Enter") {
      let IsValid = true;
      if (this.validationService.IsinValid(this.newUserPassword)) {
        this.passwordValid = false;
        IsValid = false;
      }
      else {
        this.passwordValid = true;
      }
      if (this.passwordValid && this.isPassword(this.newUserPassword) == false) {
        IsValid = false;
        this.passwordValidation = "Must contain at least one number and one uppercase and lowercase letter, and at least 8 or more characters.";
      }
      else {
        this.passwordValidation = "";
      }
    }
  }

  confirmPasswordValidation = '';
  checkConfirmPasswordValidity(event) {
    if (this.confirmPassword != null && this.confirmPassword != '') {
      if (this.newUserPassword != this.confirmPassword) {
        this.confirmPasswordValidation = 'New Password and confirm password are not matching';
      }
    }
    else {
      this.confirmPasswordValidation = 'Please enter confirm password';
    }
  }

  confirmPasswordValidity = '';
  changePasswordonAdminClick() {
    this.isDisabled = true;
    let IsValid = true;
    if (this.validationService.IsinValid(this.newUserPassword)) {
      this.passwordValid = false;
      IsValid = false;
    }
    else {
      this.passwordValid = true;
    }
    if (this.passwordValid && this.isPassword(this.newUserPassword) == false) {
      IsValid = false;
      this.passwordValidation = "Must contain at least one number and one uppercase and lowercase letter, and at least 8 or more characters.";
    }
    else {
      this.passwordValidation = "";
    }

    if (IsValid) {
      if (this.confirmPassword != null && this.confirmPassword != '') {
        if (this.newUserPassword != this.confirmPassword) {
          this.isDisabled = false;
          this.confirmPasswordValidation = 'New Password and confirm password are not matching';
        }
        else {
          this.confirmPasswordValidation = '';
          this._auth0.auth0SearchUserByEmailId(this.userEmailID).subscribe(response => {
            response.subscribe(res => {
              this.Loader.display(true);
              this._auth0.auth0UpdateUserPassword(res[0]["user_id"], this.newUserPassword).subscribe(res => {
                res.subscribe(res => {
                  this.modalRef.hide();
                  this.isDisabled = false;
                  this.Loader.display(false);
                  if (res != null) {
                    this.forgotPasswordModel = {} as IForgotPassword;
                    this.forgotPasswordModel.Guid = this.userInputModel.UserGuid;
                    this.forgotPasswordModel.ResetPassword = this.newUserPassword;
                    this.onResetPasswordClick(this.forgotPasswordModel);
                    this._toastService.addToast({
                      title: 'Success',
                      msg: 'Password changed successfully!',
                      timeout: 5000,
                      theme: 'bootstrap',
                      position: 'bottom-right',
                      type: 'success'
                    });
                  }
                });
              });
            });
          });
        }
      }
      else {
        this.isDisabled = false;
        this.confirmPasswordValidation = 'Please enter confirm password';
      }
    }
  }
  openModalChangePassword(template: TemplateRef<any>, classes: any) {
    this.confirmPasswordValidation = '';
    this.passwordValidation = '';
    this.newUserPassword = '';
    this.confirmPassword = '';
    const config = {
      ignoreBackdropClick: true,
      class: classes,
      keyboard: false,
      backdrop: true
    }
    this.modalRef = this.modalService.show(template, config);
  }

  ClearModel() {
    this.passwordValid = true;
    this.passwordValidation = '';
    this.confirmPasswordValidation = '';
  }

  handleKeydown(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      event.preventDefault();
      let passwordStatus = this.isValidConfirmPassword();
      if (passwordStatus) {
        this.isDisabled = true;
        this.changePasswordonAdminClick();
      }
    }
  }

  focusToConfirmPassword(event: KeyboardEvent, nextId: string) {
    if (event.key === 'Enter') {
      event.preventDefault();
      let passwordStatus = this.isValidpassword();
      if (passwordStatus) {
        const nextElement = document.getElementById(nextId) as HTMLElement;
        nextElement?.focus();
      }
    }
  }

  isValidpassword() {
    if ((this.isPassword(this.newUserPassword) == false) && !this.IsinValid(this.newUserPassword)) {
      this.passwordValid = false;
      this.passwordValidation = "Must contain at least one number, one uppercase letter, one lowercase letter and at least 8 characters";

      return false;
    }
    else {
      this.passwordValid = true;
      this.passwordValidation = "";
      return true;
    }
  }

  isValidConfirmPassword() {
    if (this.confirmPassword != null && this.confirmPassword != '') {
      if (this.newUserPassword != this.confirmPassword) {
        this.confirmPasswordValidation = 'New Password and confirm password are not matching';
        return false;
      }
      else {
        this.confirmPasswordValidation = '';
        return true;
      }
    }
    else {
      this.confirmPasswordValidation = 'Please enter confirm password';
      return false;
    }
  }

  async onResetPasswordClick(forgotPasswordModel:any) {
    this.forgotPasswordService.resetPassword(forgotPasswordModel).subscribe(response => {
    });
  }
}


